'use client';
import './process-status.css';

export default function ProcessStatus({ title, detail, floating = false }: { title: string; detail?: string; floating?: boolean }) {
  return <div className={`rdv-process${floating ? ' rdv-process-floating' : ''}`} role="status" aria-live="polite" aria-atomic="true">
    <span className="rdv-process-ring" aria-hidden="true" />
    <div><strong>{title}</strong>{detail && <p>{detail}</p>}</div>
    <span className="rdv-process-dots" aria-hidden="true"><i /><i /><i /></span>
  </div>;
}
